import React from 'react';
import {createRoot} from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {IonReactRouter} from "@ionic/react-router";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const container = document.getElementById('root');

if (!container) {
    throw new Error('Root element not found');
}

const root = createRoot(container);

root.render(
    <React.StrictMode>
        <IonReactRouter>
            <App/>
        </IonReactRouter>
    </React.StrictMode>
);

// Register the service worker and dispatch a custom event when an update is found.
// The App component listens for this event to show the update banner.
serviceWorkerRegistration.register({
    onUpdate: (registration) => {
        console.log('[SW] Update detected — notifying UI.');
        const event = new CustomEvent('swUpdate', { detail: registration });
        document.dispatchEvent(event);
    },
    onSuccess: (_registration) => {
        console.log('[SW] Content cached for offline use.');
    },
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
